import React from "react";
import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <Row>
            {this.props.tagLine&&
                <nav className="footer-nav">
                  <ul>
                    <li>
                      {this.props.tagLine}  <img alt="..." src={require("assets/img/flags/"+ this.props.flag +".png")}
                                    />
                    </li>
                    
                  </ul>
                </nav>
            }
            <div className="credits ml-auto">
              <span className="copyright">
                &copy; {1900 + new Date().getYear()}
                {/* , hecho con {" "} <i className="fa fa-heart heart" /> por <a href="http://www.babeligo.com" target="_blank">babeligo</a> */}
              </span>
            </div>
          </Row>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
  tagLine: PropTypes.string,
};

export default Footer;
